export const PAST_DUE_TRADE_LINE = 'PAST_DUE_TRADE_LINE';
export const PAST_DUE_TO_CURRENT = 'PAST_DUE_TO_CURRENT';
export const SCORE_CHANGE = 'SCORE_CHANGE';
export const NEW_TRADE_LINES = 'NEW_TRADE_LINES';
export const DECLINED_TRADE_LINES = 'DECLINED_TRADE_LINES';
export const GRADE_CHANGE = 'GRADE_CHANGE';
export const POTENTIAL_SCORE = 'POTENTIAL_SCORE';
export const PAYMENT_STREAK_TRADE_LINES = 'PAYMENT_STREAK_TRADE_LINES';
export const MISSED_PAYMENT_TRADE_LINE = 'MISSED_PAYMENT_TRADE_LINE';

export const EventTypeToPopupNameMap = {
  [PAST_DUE_TRADE_LINE]: 'Amount Past Due',
  [PAST_DUE_TO_CURRENT]: 'Congratulations',
  [SCORE_CHANGE]: 'Score Change',
  [NEW_TRADE_LINES]: 'New Tradeline',
  [DECLINED_TRADE_LINES]: 'Declined Tradeline',
  [GRADE_CHANGE]: 'Grade Change - ',
  [POTENTIAL_SCORE]: 'Potential Score',
  [PAYMENT_STREAK_TRADE_LINES]: 'Payment Streak',
  [MISSED_PAYMENT_TRADE_LINE]: ' Missed Payment',
};

export const EventWithConfetti = [
  PAST_DUE_TO_CURRENT,
  NEW_TRADE_LINES,
  PAYMENT_STREAK_TRADE_LINES,
];
export const EventWithConfettiPositive = [SCORE_CHANGE, GRADE_CHANGE];
